export enum DialogType {
  ADMIN,
  CMS,
  ORDERS,
  MONITOR
}
